import { jsx as o } from "@emotion/react/jsx-runtime";
import { Drawer as i } from "@partoohub/ui";
import { DeviceType as e, useDeviceType as r } from "../../../../hooks/useDeviceType.js";
import { useBusinessModalContext as l } from "../../BusinessModalContext.js";
import { BUSINESS_MODAL_DRAWER_CSS as a } from "./BusinessModalComponent.styled.js";
import { BusinessModalContent as p } from "../BusinessModalContent/BusinessModalContent.js";
const T = () => {
  const {
    open: s,
    setOpen: n
  } = l(), t = [e.Tablet, e.Mobile, e.MobileApp].includes(r());
  return /* @__PURE__ */ o(i, { cssContainer: a, isFullWidth: t, dataTrackId: "business-modal__container", isOpen: s, onHide: () => {
    n(!1);
  }, children: /* @__PURE__ */ o(p, {}) });
};
export {
  T as BusinessModalComponent
};
